import { Controller } from '@hotwired/stimulus';
import { getComponent } from '@symfony/ux-live-component';
import Swal from '@fify/form-bundle/js/tailwindAlert';

export default class SearchProfilesController extends Controller {
    async initialize() {
        this.component = await getComponent(this.element);
    }

    async delete(event) {
        const id    = event.params.id;
        const title = event.params.title;

        if (!id || !title) {
            return;
        }

        const result = await Swal.fire({
            title:             'Suche löschen?',
            html:              title,
            confirmButtonText: 'Löschen',
            cancelButtonText:  'Abbrechen',
        });

        if (result.isConfirmed) {
            await this.component.action('delete', { id })
            this.component.render();
        }
    }
}
